import React from 'react';
import { Typography, Box, FormControl, Select, MenuItem } from '@mui/material';
import { getSortedApiKeys, getSortedPyloAccounts } from '../utils/sortHelpers';

/**
 * Reusable component for API key selection
 * Displays API keys in alphabetical order by name
 */
const ApiKeySelect = ({ 
  account,
  value,
  onChange,
  size = "small",
  label = "API Key:",
  displayLabel = true,
  usePyloAccounts = false,
  fullWidth = false,
  sx = {}
}) => {
  // If no account data, return null
  if (!account) return null;

  // Determine which data source and sorting function to use
  // If usePyloAccounts is true, use pylo_accounts
  // If usePyloAccounts is false, use usage_data
  const dataSource = usePyloAccounts ? 
    getSortedPyloAccounts(account) : 
    getSortedApiKeys(account);

  // Handle the case where there's no data
  if (dataSource.length === 0) return null;
  
  return (
    <Box display="flex" alignItems="center" sx={sx}>
      {displayLabel && (
        <Typography variant="body1" mr={2}>
          {label}
        </Typography>
      )}
      <FormControl sx={{ minWidth: 100, ...(fullWidth ? { width: '100%' } : {}) }} size={size}>
        <Select
          value={value}
          onChange={(event) => onChange(event.target.value)}
          fullWidth={fullWidth}
        >
          {dataSource.map(([key, val]) => {
            // For pylo_accounts, the value is the API key
            // For usage_data, we need to find the corresponding account
            let itemValue, itemName;
            
            if (usePyloAccounts) {
              itemValue = val.api_key;
              itemName = val.name;
            } else {
              const selectedAccount = account.pylo_accounts.find(
                (account) => account.key_id === key
              );
              itemValue = key;
              itemName = selectedAccount.name;
            }
            
            return (
              <MenuItem value={itemValue} key={key}>
                {itemName}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </Box>
  );
};

export default ApiKeySelect;
